module.exports = __webpack_public_path__ + "assets/img/ruta-jakubauskiene.43ae2288.jpg";